import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { HeartHandshakeIcon, MonitorIcon, CalendarCheckIcon, ShieldCheckIcon } from 'lucide-react';
const features = [{
  title: 'Friendly Expert Staff',
  description: 'Our compassionate team ensures you feel comfortable and well-cared for during every visit.',
  icon: HeartHandshakeIcon
}, {
  title: 'Advanced Technology',
  description: 'We use state-of-the-art diagnostic equipment for precise, early detection of eye conditions.',
  icon: MonitorIcon
}, {
  title: 'Easy Online Booking',
  description: 'Schedule your appointments anytime, anywhere with our seamless online booking system.',
  icon: CalendarCheckIcon
}, {
  title: 'Insurance Accepted',
  description: 'We work with most major vision and medical insurance providers to maximize your benefits.',
  icon: ShieldCheckIcon
}];
export function FeaturesSection() {
  return <section id="features" className="py-20 md:py-28 bg-white" data-id="element-223">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-224">
        <div className="flex flex-col lg:flex-row gap-16 items-center" data-id="element-225">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="lg:w-1/3" data-id="element-226">
            <h2 className="text-section-mobile md:text-section text-brand-dark mb-6" data-id="element-227">
              Why Choose VisualEyes?
            </h2>
            <p className="text-lg text-neutral-text/80 mb-8 leading-relaxed" data-id="element-228">
              We believe that exceptional eye care goes beyond just a
              prescription. It's about building lasting relationships and
              providing an experience that makes you feel valued and understood.
            </p>
            <a href="https://appointments.4patientcare.app/?CoverKey=5118&Source=website%20WebSchedV4&ReferredBy=Unknon&Gcount=0" target="_blank" rel="noreferrer" className="inline-flex items-center justify-center bg-brand-gold text-white px-8 py-3.5 rounded-button font-heading font-semibold hover:bg-brand-gold-light transition-colors shadow-md focus-ring" data-id="element-229">
              Experience the Difference
            </a>
          </motion.div>

          <div className="lg:w-2/3 grid grid-cols-1 sm:grid-cols-2 gap-8" data-id="element-230">
            {features.map((feature, index) => {
            const Icon = feature.icon;
            return <motion.div key={feature.title} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.1
            }} className="flex gap-4" data-id="element-231">
                  <div className="flex-shrink-0 w-12 h-12 bg-brand-gold/10 rounded-full flex items-center justify-center" data-id="element-232">
                    <Icon className="w-6 h-6 text-brand-gold" data-id="element-233" />
                  </div>
                  <div data-id="element-234">
                    <h3 className="text-xl font-heading font-semibold text-brand-dark mb-2" data-id="element-235">
                      {feature.title}
                    </h3>
                    <p className="text-neutral-text/70 leading-relaxed" data-id="element-236">
                      {feature.description}
                    </p>
                  </div>
                </motion.div>;
          })}
          </div>
        </div>
      </div>
    </section>;
}